import { render, staticRenderFns } from "./spine.vue?vue&type=template&id=637cd507&scoped=true&"
import script from "./spine.vue?vue&type=script&lang=js&"
export * from "./spine.vue?vue&type=script&lang=js&"
import style0 from "./spine.vue?vue&type=style&index=0&id=637cd507&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637cd507",
  null
  
)

export default component.exports